import METADATA from '@/api/metadata'

const state = {
  metadata: null
}

const getters = {
  metadata: (state) => {
    return state.metadata
  }
}

const actions = {
  fetchMetadata ({ commit }) {
    return METADATA.fetchMetadata()
      .then(res => {
        if (res.data) {
          commit('SET_METADATA', res.data)
          return res.data
        }
        return res
      })
  }
}

const mutations = {
  SET_METADATA: function (state, payload) {
    state.metadata = payload
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
